import { AppIcon, Button, Row, styled, useTheme } from '@streem/ui-react';
import { CSSProperties, FC, PropsWithChildren } from 'react';
import { streem } from 'streem-sdk-protobuf';
import { useTimeStampController } from '../../../../hooks/use_timestamp_controller';

export const AddNewBookmark: FC<
    PropsWithChildren<{
        addBookmark: (bookmark: streem.api.Artifact.IBookmark) => void;
        WrapperComponent?: FC<React.PropsWithChildren>;
        buttonTextStyles?: CSSProperties;
    }>
> = ({ addBookmark, WrapperComponent, buttonTextStyles = {} }) => {
    const { getNewBookmarkTimeStamp, convertSecondsToTimestamp } = useTimeStampController();
    const theme = useTheme();

    const Wrapper = WrapperComponent || NewBookmarkWrapper;
    const effectiveButtonTextStyles = {
        marginLeft: '6px',
        fontSize: '18px',
        ...buttonTextStyles,
    };

    return (
        <Wrapper>
            <Button
                variant="tertiary"
                onClick={() => {
                    const time = getNewBookmarkTimeStamp();
                    addBookmark({
                        timestamp: convertSecondsToTimestamp(time),
                    });
                }}
            >
                <AppIcon color={theme.colors.azure} name="AddBookmarkIcon" />{' '}
                <span style={effectiveButtonTextStyles}>Add Bookmark</span>
            </Button>
        </Wrapper>
    );
};

const NewBookmarkWrapper = styled(Row)({
    justifyContent: 'left',
    margin: '.75rem 0',
});
